module.exports = __webpack_public_path__ + "img/logo-hunhelps.b2fbaf8e.png";